import WIDGETS from './widgets';

export default {
	name: 'opti_practitioner_dashboard',
	widgets: [
		{ content: WIDGETS.TICKETS_REFERRALS, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
	],
};